export enum AppActionTypes {
  // Global
  UPDATE_PROFILE = 'UPDATE_PROFILE',
}
